import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { CurrencyPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ChatStatus } from 'src/shared/stores/chat/chat-data.store';

@Component({
  selector: 'app-chat-with-vet-dialog',
  imports: [CurrencyPipe],
  templateUrl: './chat-with-vet-dialog.component.html',
  styleUrl: './chat-with-vet-dialog.component.scss',
})
export class ChatWithVetDialogComponent {
  data = inject(DIALOG_DATA);
  dialogRef = inject(DialogRef);

  onClick() {
    this.dialogRef.close(ChatStatus.curious);
  }
}
